import * as React from 'react';
export const checkSvg = React.forwardRef(function checkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D8DEE4',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.938 19.453c0-.518.42-.938.937-.938h3.75a.937.937 0 1 1 0 1.875h-3.75a.938.938 0 0 1-.938-.937Z',
      fill: '#474E5A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.75 7.89A3.75 3.75 0 0 0 6 11.64v8.75a3.75 3.75 0 0 0 3.75 3.75h12.5A3.75 3.75 0 0 0 26 20.39v-8.75a3.75 3.75 0 0 0-3.75-3.75H9.75Zm12.5 1.875H9.75c-.7 0-1.312.385-1.633.954a.94.94 0 0 1 .202.08l7.533 4.056a.31.31 0 0 0 .296 0L23.68 10.8a.943.943 0 0 1 .203-.081 1.874 1.874 0 0 0-1.633-.954Zm1.875 2.925-7.088 3.816a2.188 2.188 0 0 1-2.074 0L7.875 12.69v7.7c0 1.036.84 1.875 1.875 1.875h12.5c1.035 0 1.875-.84 1.875-1.875v-7.7Z',
      fill: '#474E5A',
    }),
  );
});
checkSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var check = {
  category: 'brand',
  colorable: false,
  name: 'check',
  svg: checkSvg,
};
